import React from "react";
import Marquee from "react-fast-marquee";
import PrimaryHeading from "../custom-ui/PrimaryHeading";

function LogoSlider() {
  return (
    <div className="max-w-[1920px] mx-auto lg:mt-[140px] md:mt-24 mt-16">
      {/* First marquee container with rotation and styling */}
      <div className="bg-light-purple scale-110 border-t-8 border-persian-blue rotate-[9deg] lg:rotate-[6deg] xl:rotate-6 relative z-30 md:z-10">
        <Marquee speed={30} direction="left">
          {/* Generate 10 PrimaryHeading components with text "$Dunce" */}
          {Array(10)
            .fill()
            .map((_, index) => (
              <div key={index}>
                <PrimaryHeading className="md:h-[50px] text-white lg:h-[70px] xl:h-[90px] px-[11px] md:px-6 lg:px-8 xl:px-[33px] !text-xl md:!text-3xl lg:!text-[35px] 2xl:!text-5xl flex justify-center items-center">
                  $Dunce
                </PrimaryHeading>
              </div>
            ))}
        </Marquee>
      </div>
      {/* Second marquee container with opposite rotation and styling */}
      <div className="bg-light-purple scale-110 border-t-8 border-persian-blue row-span-2 -rotate-[4deg] md:-rotate-[7deg] lg:-rotate-[6deg] xl:-rotate-6 -mt-[28px] md:-mt-[60px] lg:-mt-[80px] xl:-mt-[100px] relative z-20">
        <Marquee speed={30} direction="right">
          {/* Generate 10 PrimaryHeading components with text "$Dunce" */}
          {Array(10)
            .fill()
            .map((_, index) => (
              <div key={index}>
                <PrimaryHeading className="md:h-[50px] text-white lg:h-[70px] xl:h-[90px] px-[11px] md:px-6 lg:px-8 xl:px-[33px] !text-xl md:!text-3xl lg:!text-[35px] 2xl:!text-5xl flex justify-center items-center">
                  $Dunce
                </PrimaryHeading>
              </div>
            ))}
        </Marquee>
      </div>
    </div>
  );
}

export default LogoSlider;
